import styled from 'styled-components';
import { Link } from "react-router-dom";
import InputMask from "react-input-mask";
import { FormText } from 'reactstrap';
import CPF from '../../assets/img/icones/CPF';
import Cadeado from '../../assets/img/icones/Cadeado';

export const DivLabel = styled.div`
    min-width: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const Fundo = styled.div`
    display: flex;
    height: calc(100vh - 120px);
    width: 100vw;;
    justify-content: center;
    background-color: var(--primary);
    margin-left: 0px;
`;

export const Card = styled.div`
    background-color: var(--primary);
    padding: 40px 50px; 
    border: 0px; 
`;

export const DivInput = styled.div`
    display: grid;
`;

export const CustomFormText = styled(FormText)`
    width: 100%;
    height: 50px;
    background-color: #D24451;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const TextLogin = styled.text`
    color: var(--primary);
`;

export const EsqueciSenha = styled.section`
    display: flex;
    width: 100%;
    height: 18px;
    gap: 10px;
    justify-content: right;
    align-items: right;
    margin-top: 10px;
`;

export const TextLabel = styled.text`
    font-size: 15px;
    color: #FFFFFF;
`;

export const CustomInput = styled(InputMask)`
    padding: 0.5em;
    margin: 0.5em;
    background: var(--primary);
    color: #FFFFFF;
    border-style: solid;
    border-bottom-width: 1px #FFFFFF;
    border-top-width: 0;
    border-right-width: 0;
    border-left-width: 0;

    &:focus {
        box-shadow: 0 0 0 0;
        outline: 0;
        background: var(--primary);
        color: #FFFFFF;
        border: 1px solid var(--primary);
    }
    
    &::-webkit-input-placeholder {
        color: #FFFFFF;
    }

    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus,
    &:-webkit-autofill:active {
      -webkit-transition: "color 9999s ease-out, background-color 9999s ease-out";
      -webkit-transition-delay: 9999s;
    }
`;

export const CustomLink = styled(Link)`
    text-decoration: none;
    color: #FFFFFF;
    font-size: 15px;

    &:hover {
        color: #FFFFFF;
    }
`;

export const CustomCPF = styled(CPF)`
    width: 40px;
    height: 40px;

    & path {
        fill: #000000;
        color: #000000;
    }
`;

export const CustomCadeado = styled(Cadeado)`
    & path {
        fill: #FFFFFF;
        color: #FFFFFF;
    }
`;

export const Text = styled.p`
    font-size: 18px;
    color: var(--white);
    text-align: center;
`;

export const CustomInput2 = styled(InputMask)`
    background: var(--primary);
    color: #FFFFFF;
    border: 1px solid var(--white);
    border-radius: 30px;
    width: 100%;
    height: 40px;
    margin-top: -18px;
    padding-left: 10px;

    &:focus {
        box-shadow: 0 0 0 0;
        outline: 0;
        background: var(--primary);
        color: #FFFFFF;
        border: 1px solid var(--white);
    }
    
    &::-webkit-input-placeholder {
        color: #FFFFFF;
    }

    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus,
    &:-webkit-autofill:active {
      -webkit-transition: "color 9999s ease-out, background-color 9999s ease-out";
      -webkit-transition-delay: 9999s;
    }
`;

export const TextLight = styled.p`
    font-size: 10px;
    color: var(--white);
    margin-left: 10px;
`;

export const DivTeste = styled.div`
    background-color: #336AA7;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const DivBody = styled.div`
    margin: 0;
`;

export const Text2 = styled.p`
    font-size: 12px;
    color: var(--white);
    text-align: center;
`;